import { render, staticRenderFns } from "./ClassifyDashboard.vue?vue&type=template&id=e17f3670&scoped=true"
import script from "./ClassifyDashboard.vue?vue&type=script&lang=js"
export * from "./ClassifyDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClassifyDashboard.vue?vue&type=style&index=0&id=e17f3670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17f3670",
  null
  
)

export default component.exports